import React, { useState, useEffect } from "react";
import "../App.css";
import './Profile.css';
import { Link } from 'react-router-dom';
import pic from "../assets/default_pfp.png"
import logo from '../assets/logo.png'
import { useNavigate } from "react-router-dom";
import Modal from './Modal';
import Header from './Header'
import translations from './translation.js';


const Profile = (props) => {
  const [userID, setUserID] = useState("")
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [messageclass, setMessageClass] = useState("");
  const [picture, setPicture] = useState("");
  const [userRanks, setUserRanks] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showRankModal, setShowRankModal] = useState(false);
  const navigate = useNavigate();
  const currentLanguage = localStorage.getItem('selectedLanguage') || "en";


  const [attributes, setAttributes] = useState({})
  const [rankFormData, setRankFormData] = useState({
    valorant: "",
    dota_2: "",
    league_of_legends: "",
    fortnite: "",
    cs2: "",
    apex_legends: ""
  })

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => { 
    await fetch(
      `${process.env.REACT_APP_API_PATH}/users/${sessionStorage.getItem(
        "user"
      )}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if (result && result.attributes) {
          console.log(result)
          setUserID(result.id)
          setUsername(result.attributes.username);
          setEmail(result.email);
          setPicture(result.attributes.picture);
          setAttributes(result.attributes)
          if (result.attributes.ranks) {
            setUserRanks(result.attributes.ranks)
          }
          else {
            setUserRanks({
              valorant: "Unranked",
              dota_2: "Unranked",
              league_of_legends: "Unranked",
              fortnite: "Unranked",
              cs2: "Unranked",
              apex_legends: "Unranked"
            })
          }
        }
      })
      .catch((error) => {
        alert("error!");
        setResponseMessage("Issue Retrieving Your Data");
        setMessageClass("response_error");
        setTimeout(() => {
          setResponseMessage("");
        }, 2000);
      });
  }

  useEffect(() => {
    if (!sessionStorage.getItem("token")) {
      navigate("/login");
    }
  }, []);

  const submitHandler = (event) => {
    event.preventDefault();

    const updatedAttributes = {
      ...attributes,
      username: username,
      picture: picture, 
    };

    fetch(
      `${process.env.REACT_APP_API_PATH}/users/${sessionStorage.getItem(
        "user"
      )}`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          attributes: updatedAttributes,
        }),
      }
    )
      .then((res) => res.json())
      .then((result) => {
        setResponseMessage("Success");
        setMessageClass("response_success");
        setTimeout(() => {
          setResponseMessage("");
        }, 2000);
        navigate(`/user/${userID}`)
      })
      .catch((error) => {
        alert("error!");
        setResponseMessage("Change Failed");
        setMessageClass("response_error");
        setTimeout(() => {
          setResponseMessage("");
        }, 2000);
      });
  };

  const handleModal = () => {
    setShowModal(true);
  }

  const handleRankModal = () => {
    setShowRankModal(true);
  }

  const handleDeleteAccount = () => {
    fetch(
      `${process.env.REACT_APP_API_PATH}/users/${sessionStorage.getItem(
        "user"
      )}?relatedObjectsAction=delete`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      }
    )
      .then(() => {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("user");
        navigate("/login")
        }
      )
  }

  const handleRankSelects = (event) => {
    let rank = event.target.value;
    let game = event.target.id;

    setRankFormData({
      ...rankFormData,
      [game]: rank
    })
  }

  const handleRankUpdate = async () => {
    const finalFormData = {
      valorant : "",
      dota_2 : "",
      league_of_legends : "",
      fortnite : "",
      cs2 : "",
      apex_legends : ""
    }

    if (rankFormData.valorant !== "") {
      finalFormData.valorant = rankFormData.valorant;
    } else {finalFormData.valorant = document.getElementById("valorant").value}
    if (rankFormData.dota_2 !== "") {
      finalFormData.dota_2 = rankFormData.dota_2;
    } else {finalFormData.dota_2 = document.getElementById("dota_2").value}
    if (rankFormData.league_of_legends !== "") {
      finalFormData.league_of_legends = rankFormData.league_of_legends;
    } else {finalFormData.league_of_legends = document.getElementById("league_of_legends").value}
    if (rankFormData.fortnite !== "") {
      finalFormData.fortnite = rankFormData.fortnite;
    } else {finalFormData.fortnite = document.getElementById("fortnite").value}
    if (rankFormData.cs2 !== "") {
      finalFormData.cs2 = rankFormData.cs2;
    } else {finalFormData.cs2 = document.getElementById("cs2").value}
    if (rankFormData.apex_legends !== "") {
      finalFormData.apex_legends = rankFormData.apex_legends;
    } else {finalFormData.apex_legends = document.getElementById("apex_legends").value}


    const updatedAttributes = { ...attributes, "ranks": finalFormData };

    fetch(`${process.env.REACT_APP_API_PATH}/users/${userID}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
      body: JSON.stringify({
        attributes: updatedAttributes
      })
    })

    setShowRankModal(false);
    fetchUserData();
  }

  const uploadPicture = (event) => {
    event.preventDefault();
    const file = event.target.files[0];
    const formData = new FormData();

    formData.append("uploaderID", sessionStorage.getItem("user"));
    formData.append("attributes", JSON.stringify({}));
    formData.append("file", file);

    // make api call to file-uploads endpoint to post the profile picture
    fetch(process.env.REACT_APP_API_PATH + "/file-uploads", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => {
        let pictureURL = "https://webdev.cse.buffalo.edu" + result.path;
        setPicture(pictureURL);
      });
  };

  return (
    <>
    <Header />
    <div className="total">
      
      {/* <Link to="/feed">
        <img src={ logo } alt="logo" className="logo"/>
      </Link> */}
      <form onSubmit={submitHandler} className="profileform">
      <label htmlFor="profilePicture" className="profilePicLabel">
        <div className="profilePicContainer">
          <img src={picture || pic} alt="picture" className="profilePic" />
          <button type="button" className="uploadButton" onClick={() => document.getElementById('profilePicture').click()}>
            {translations[currentLanguage].upload}
          </button>
            </div>
            <input
              type="file"
              accept="image/*"
              onChange={uploadPicture}
              id="profilePicture"
              style={{ display: 'none' }}
            />
          </label>


        <div className="pro-nav">
          <Link to={`/userPosts`}><button>{translations[currentLanguage].edit_posts}</button></Link>
          <Link to="/profile"><button>{translations[currentLanguage].profile}</button></Link>
          {/* <Link to="/status"><button>{translations[currentLanguage].status}</button></Link> */}
        </div>

        <div className='wrap'>
          <div className="input">
            <input 
              type='text' 
              placeholder='Username'
              id='username'
              onChange={(e) => setUsername(e.target.value)}
              value={username}
               />
          </div>
          <div className="input">
            <input 
              type='text' 
              placeholder='Email'
              id='email'
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              required />
          </div>
          <div className='Txt'>
            <button type="button" onClick = {handleRankModal}>{translations[currentLanguage].add_rank}</button>
          </div>
          <button type='submit'>{translations[currentLanguage].save_change}</button>
          <div className="response-message">
            {responseMessage && <p className={messageclass}>{responseMessage}</p>}
          </div>
        </div>
        {/* <div className="return">  <Link to="/feed"><button>Return</button></Link> </div> */}
      </form>

      {/* Modal to show account deletion verification */}
      <Modal show = {showModal} onClose={() => setShowModal(false)}>
        <h1>{translations[currentLanguage].delete_account_message}</h1>
        <button onClick = {handleDeleteAccount}>{translations[currentLanguage].yes}</button>
        <button onClick = {() => setShowModal(false)}>{translations[currentLanguage].no}</button>
      </Modal>

      <Modal show={showRankModal} onClose={() => setShowRankModal(false)} className="ranking_modal">
        <h1>{translations[currentLanguage].edit_rank}</h1>
        <div className="ranking_display">
          <label htmlFor="valorant" style={{fontWeight : "bold", color : "#D1B140"}}>{translations[currentLanguage].valorant} : </label>
          <select 
            id="valorant" 
            defaultValue={userRanks.valorant} 
            onChange={handleRankSelects}
          >
            <option value="unranked">{translations[currentLanguage].unranked}</option>
            <option value="valorant_iron">{translations[currentLanguage].valorant_iron}</option>
            <option value="valorant_bronze">{translations[currentLanguage].valorant_bronze}</option>
            <option value="valorant_silver">{translations[currentLanguage].valorant_silver}</option>
            <option value="valorant_gold">{translations[currentLanguage].valorant_gold}</option>
            <option value="valorant_platinum">{translations[currentLanguage].valorant_platinum}</option>
            <option value="valorant_diamond">{translations[currentLanguage].valorant_diamond}</option>
            <option value="valorant_ascendant">{translations[currentLanguage].valorant_ascendant}</option>
            <option value="valorant_immortal">{translations[currentLanguage].valorant_immortal}</option>
            <option value="valorant_radiant">{translations[currentLanguage].valorant_radiant}</option>
          </select>

          <label htmlFor="dota_2" style={{fontWeight : "bold", color : "#D1B140"}}>{translations[currentLanguage].dota_2} : </label>
          <select 
            id="dota_2"
            defaultValue={userRanks.dota_2} 
            onChange={handleRankSelects}
          >
            <option value="unranked">{translations[currentLanguage].unranked}</option>
            <option value="dota_2_herald">{translations[currentLanguage].dota_2_herald}</option>
            <option value="dota_2_guardian">{translations[currentLanguage].dota_2_guardian}</option>
            <option value="dota_2_crusader">{translations[currentLanguage].dota_2_crusader}</option>
            <option value="dota_2_archon">{translations[currentLanguage].dota_2_archon}</option>
            <option value="dota_2_legend">{translations[currentLanguage].dota_2_legend}</option>
            <option value="dota_2_ancient">{translations[currentLanguage].dota_2_ancient}</option>
            <option value="dota_2_divine">{translations[currentLanguage].dota_2_divine}</option>
          </select>

          <label htmlFor="league_of_legends" style={{fontWeight : "bold", color : "#D1B140"}}>{translations[currentLanguage].league_of_legends} : </label>
          <select 
            id="league_of_legends"
            defaultValue={userRanks.league_of_legends} 
            onChange={handleRankSelects}
          >
            <option value="unranked">{translations[currentLanguage].unranked}</option>
            <option value="league_of_legends_iron">{translations[currentLanguage].league_of_legends_iron}</option>
            <option value="league_of_legends_bronze">{translations[currentLanguage].league_of_legends_bronze}</option>
            <option value="league_of_legends_silver">{translations[currentLanguage].league_of_legends_silver}</option>
            <option value="league_of_legends_gold">{translations[currentLanguage].league_of_legends_gold}</option>
            <option value="league_of_legends_platinum">{translations[currentLanguage].league_of_legends_platinum}</option>
            <option value="league_of_legends_emerald">{translations[currentLanguage].league_of_legends_emerald}</option>
            <option value="league_of_legends_diamond">{translations[currentLanguage].league_of_legends_diamond}</option>
            <option value="league_of_legends_master">{translations[currentLanguage].league_of_legends_master}</option>
            <option value="league_of_legends_grandmaster">{translations[currentLanguage].league_of_legends_grandmaster}</option>
            <option value="league_of_legends_challenger">{translations[currentLanguage].league_of_legends_challenger}</option>
          </select>

          <label htmlFor="fortnite" style={{fontWeight : "bold", color : "#D1B140"}}>{translations[currentLanguage].fortnite} : </label>
          <select 
            id="fortnite"
            defaultValue={userRanks.fortnite} 
            onChange={handleRankSelects}
          >
            <option value="unranked">{translations[currentLanguage].unranked}</option>
            <option value="fortnite_iron">{translations[currentLanguage].fortnite_iron}</option>
            <option value="fortnite_bronze">{translations[currentLanguage].fortnite_bronze}</option>
            <option value="fortnite_silver">{translations[currentLanguage].fortnite_silver}</option>
            <option value="fortnite_gold">{translations[currentLanguage].fortnite_gold}</option>
            <option value="fortnite_platinum">{translations[currentLanguage].fortnite_platinum}</option>
            <option value="fortnite_diamond">{translations[currentLanguage].fortnite_diamond}</option>
            <option value="fortnite_elite">{translations[currentLanguage].fortnite_elite}</option>
            <option value="fortnite_champion">{translations[currentLanguage].fortnite_champion}</option>
            <option value="fortnite_unreal">{translations[currentLanguage].fortnite_unreal}</option>
          </select>

          <label htmlFor="cs2" style={{fontWeight : "bold", color : "#D1B140"}}>{translations[currentLanguage].counter_strike} : </label>
          <select 
            id="cs2"
            defaultValue={userRanks.cs2} 
            onChange={handleRankSelects}

          >
            <option value="unranked">{translations[currentLanguage].unranked}</option>
            <option value="counter_strike_silver">{translations[currentLanguage].counter_strike_silver}</option>
            <option value="counter_strike_gold_nova">{translations[currentLanguage].counter_strike_gold_nova}</option>
            <option value="counter_strike_master_guardian">{translations[currentLanguage].counter_strike_master_guardian}</option>
            <option value="counter_strike_distinguished_master_guardian">{translations[currentLanguage].counter_strike_distinguished_master_guardian}</option>
            <option value="counter_strike_legendary_eagle">{translations[currentLanguage].counter_strike_legendary_eagle}</option>
            <option value="counter_strike_legendary_eagle_master">{translations[currentLanguage].counter_strike_legendary_eagle_master}</option>
            <option value="counter_strike_supreme_master_first_class">{translations[currentLanguage].counter_strike_supreme_master_first_class}</option>
            <option value="counter_strike_global_elite">{translations[currentLanguage].counter_strike_global_elite}</option>
          </select>

          <label htmlFor="apex_legends" style={{fontWeight : "bold", color : "#D1B140"}}>{translations[currentLanguage].apex_legends} : </label>
          <select 
            id="apex_legends"
            defaultValue={userRanks.apex_legends} 
            onChange={handleRankSelects}
          >
            <option value="unranked">{translations[currentLanguage].unranked}</option>
            <option value="apex_legends_bronze">{translations[currentLanguage].apex_legends_bronze}</option>
            <option value="apex_legends_silver">{translations[currentLanguage].apex_legends_silver}</option>
            <option value="apex_legends_gold">{translations[currentLanguage].apex_legends_gold}</option>
            <option value="apex_legends_platinum">{translations[currentLanguage].apex_legends_platinum}</option>
            <option value="apex_legends_diamond">{translations[currentLanguage].apex_legends_diamond}</option>
            <option value="apex_legends_master">{translations[currentLanguage].apex_legends_master}</option>
            <option value="apex_legends_apex_predator">{translations[currentLanguage].apex_legends_apex_predator}</option>
          </select>
        </div>
        <button onClick={() => setShowRankModal(false)}>{translations[currentLanguage].close}</button>
        <button onClick={handleRankUpdate}>{translations[currentLanguage].save}</button>
      </Modal>
    </div>
    </>
  );
  
};

export default Profile;
